import React from 'react';
import { string } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import { LEARN_MORE_TRACKER_POS } from '../../../../shared/constants';
import { reportCreateNewLogoClick } from '../../../../shared/reportEvents/bigQuery';
import useOnHeaderNewLogoLinkClick from '../../../../shared/hooks/useOnHeaderNewLogoLinkClick';
import { AVATAR_PROPS } from '../../../../shared/reportEvents/bigQuery/reportCreateNewLogoClick/constants';
import Breadcrumbs from '../../../../shared/components/Breadcrumbs';
import { getBreadcrumbList, getBriefUrl } from '../../../../shared/lib';
import SCREEN_BREAKPOINTS from '../../../../shared/constants/screenBreakpoints';
import { APP_NAME } from '../../../../server/middlewares/BuyerIdeas/constants';
import { FEATURE_LOGO_OVERLAY_IMAGE } from '../propTypes/featuredLogoOverlayImage';
import { getStartedClicked } from '../lib/bi-events';
import { HERO_CTA } from '../propTypes/heroCta';
import { INNER_CLASSES } from '../constants';
import './style.scss';

const IntroHeader = ({
    featuredImageAlt,
    featuredLogoOverlayImage,
    heroCta: { headline, standfirstText } = {},
    brandName,
    slogan,
    tagId,
    tagType,
    tagName,
}) => {
    const trackGetStartedClick = (elementText) =>
        getStartedClicked({
            elementText,
            elementPosition: LEARN_MORE_TRACKER_POS.top,
            elementName: 'make your logo',
            pageTagType: tagType,
            pageTagId: tagId,
        });
    const onNewLogoLinkClick = () => {
        reportCreateNewLogoClick({
            pageName: APP_NAME,
            ...AVATAR_PROPS,
        });
    };
    const breadcrumbsList = getBreadcrumbList({
        type: tagType,
        id: tagId,
        name: tagName,
    });

    useOnHeaderNewLogoLinkClick(onNewLogoLinkClick);

    return (
        <header className="intro-header hero-section">
            <div className={INNER_CLASSES}>
                <div className="intro-header-image">
                    <div className="feature-image">
                        <picture>
                            <source
                                media={`(min-width: ${SCREEN_BREAKPOINTS.lg}px)`}
                                srcSet={featuredLogoOverlayImage.large}
                            />
                            <source
                                media={`(min-width: ${SCREEN_BREAKPOINTS.md}px)`}
                                srcSet={featuredLogoOverlayImage.middle}
                            />
                            <source
                                media={`(min-width: ${SCREEN_BREAKPOINTS.sm}px)`}
                                srcSet={featuredLogoOverlayImage.small}
                            />
                            <img src={featuredLogoOverlayImage.default} alt={featuredImageAlt} />
                        </picture>

                        {/*
                                    Square, image resizing simulation.
                                    Used to have height related to width
                                    and prevent container height jumping during image loading
                                */}
                        <svg viewBox="0 0 4.37 3.05" />
                    </div>
                </div>
                <div className="intro-header-content">
                    <Breadcrumbs list={breadcrumbsList} theme={Breadcrumbs.THEMES.DARK} />

                    <h1>{headline}</h1>
                    <p>{standfirstText}</p>

                    <Button
                        rel="nofollow"
                        className="intro-header-btn"
                        color={Button.COLORS.WHITE}
                        textColor={Button.TEXT_COLORS.DARK_GREY}
                        onClick={() => trackGetStartedClick(translate('logo_maker_perseus.general.make_your_logo'))}
                        href={getBriefUrl({
                            brandName,
                            slogan,
                            tagType,
                            tagId,
                        })}
                    >
                        <I18n k="logo_maker_perseus.general.make_your_logo" />
                    </Button>
                </div>
            </div>
        </header>
    );
};

IntroHeader.propTypes = {
    heroCta: HERO_CTA,
    brandName: string,
    slogan: string,
    tagId: string,
    tagType: string,
    tagName: string,
    featuredImageAlt: string,
    featuredLogoOverlayImage: FEATURE_LOGO_OVERLAY_IMAGE,
};

export default IntroHeader;
